import { cmtsRouteManifest } from "./cmtsRouteManifest.js";

function normalizeRoutePath(path: string | undefined): string {
  if (!path) return "";
  const [withoutHash] = path.split("#", 1);
  const [withoutQuery] = (withoutHash ?? "").split("?", 1);
  const normalized = (withoutQuery ?? "").trim().replace(/\/+$/, "");
  return normalized || "/";
}

const routeByPath = new Map(cmtsRouteManifest.map((route) => [normalizeRoutePath(route.path), route]));

export function isCmtsRegisteredRoutePath(path: string | undefined): boolean {
  return routeByPath.has(normalizeRoutePath(path));
}

export function getCmtsRoutePermissionForPath(path: string | undefined): string | undefined {
  return routeByPath.get(normalizeRoutePath(path))?.permission;
}

export function getCmtsRouteTitleForPath(path: string | undefined): string | undefined {
  return routeByPath.get(normalizeRoutePath(path))?.title;
}

export function getCmtsRouteManifestPaths(): readonly string[] {
  return Array.from(routeByPath.keys()).sort();
}
